import { dataVideoHistory } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoHistory = /*#__PURE__*/createIcon(dataVideoHistory)
export default IconVideoHistory
